

import { usuariosApi } from "../../apis";
import { useAuthStore } from "../../stores/usuarios/auth.store";
import { useUsuariosStore } from "../../stores/usuarios/usuarios.store";

import Swal from "sweetalert2";


export const usuarioPorID = async(id) => {
    try {
        const { data } = await usuariosApi.get(`/por-id/${id}`);
        return data.usuario;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}



export const startSavingUsuario = async( datos ) => {
    try {
        await usuariosApi.post('new', datos);
        Swal.fire('Exitoso', 'Usuario Creado', 'success');
        return true;
    } catch (error) {
        console.log(error);
        Swal.fire('Error', error.response.data?.msg || '', 'error');
        return false;
    }
} 



export const startSavingCliente = async( datos ) => {
    try {
        await usuariosApi.post('new/cliente', datos);
        Swal.fire('Exitoso', 'Cliente Creado', 'success');
        return true;
    } catch (error) {
        Swal.fire('Error', error.response.data?.msg || '', 'error');
        return false;
    }
} 



export const startCreateCuenta = async( datos ) => {
    try {
        const { data } = await usuariosApi.post('crear/micuenta', datos);
        Swal.fire('Exitoso', 'Tu cuenta fue creada ingresa con el numero celular y esta contraseña, seven123', 'success');
        useAuthStore.setState({ cliente: data.usuario, tokenCliente:data.token });
        return true;
    } catch (error) {
        Swal.fire('Error', error.response.data?.msg || '', 'error');
        return false;
    }
} 



export const startEditarUsuario = async( user ) => {
    try {
        const formData = new FormData();
        if (user?.img && typeof user?.img !== 'string') {
            formData.append('images', user.img);
        }

        Object.entries(user).forEach(([key, value]) => {
            formData.append(key, value?.toString());
        });
        const { data } = await usuariosApi.put(`/${user.id}`, formData);
        Swal.fire('Exitoso', 'Usuario Actualizado', 'success');
        return data.usuario;

    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}



export const startEditarDesdeVenta = async( user ) => {
    try {
        await usuariosApi.put(`/inventa/${user.id}`, user);
        Swal.fire('Exitoso', 'Checkout Realizado', 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}




export const listadoUsuariosRol = async({ page=0, termino='', rol }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);
        params.append('rol',  rol.join(','));

        const { data } = await usuariosApi.get('/listuser/xrol', { params });
        useUsuariosStore.setState({ total: data.total });
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}




export const listadoMisClientes = async({ page=0, termino='' }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);

        const { data } = await usuariosApi.get('/me/clientes', { params });
        useUsuariosStore.setState({ total: data.total });
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}



export const cambiarEstadoUsuario = async(id) => {
    try {
        const { data } = await usuariosApi.get(`/cambioestado/${id}`);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}



export const configuracionPermisos = async(permiso) => {
    try {
        const { data } = await usuariosApi.post(`/permisos`, permiso);
        Swal.fire('Exitoso', 'Ajustes en Permiso', 'success');
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}



export const listadoUsuariosVenta = async(termino) => {
    try {
        const { data } = await usuariosApi.get(`/listuser/venta/${termino}`);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}



export const listadoUsuariosColaborador = async(termino) => {
    try {
        const { data } = await usuariosApi.get(`/listuser/colaborador/${termino}`);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}


